import { stats, trustPoints } from '@/mocks/home';

export default function TrustStats() {
  return (
    <section id="trust" className="w-full py-14 md:py-20 bg-background-100 border-y border-background-200">
      <div className="w-full px-4 md:px-8">
        {/* stats band */}
        <div className="rounded-lg bg-foreground-950 px-5 md:px-10 py-8 md:py-10">
          <div className="flex items-center gap-2 mb-7">
            <i className="ri-line-chart-line text-accent-400 text-lg"></i>
            <span className="text-xs font-label text-background-200 tracking-[0.2em]">
              收录规模与更新节奏
            </span>
          </div>
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
            {stats.map((stat) => (
              <div key={stat.id} className="flex flex-col">
                <span className="w-9 h-9 rounded-md bg-background-50/10 text-accent-400 flex items-center justify-center mb-3">
                  <i className={`${stat.icon} text-lg`}></i>
                </span>
                <span className="flex items-baseline gap-1">
                  <span className="font-heading font-bold text-background-50 text-2xl md:text-3xl">
                    {stat.value}
                  </span>
                  <span className="text-xs font-label text-background-300">{stat.unit}</span>
                </span>
                <span className="mt-1.5 text-xs font-label text-background-300">{stat.label}</span>
              </div>
            ))}
          </div>
        </div>

        {/* trust points */}
        <div className="mt-8 md:mt-10 flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-8">
          <div>
            <span className="text-xs font-label text-secondary-600 tracking-[0.2em]">HOW IT WORKS</span>
            <h2 className="mt-2 font-heading font-bold text-foreground-950 text-2xl md:text-3xl tracking-tight">
              我们怎么整理这些语音
            </h2>
          </div>
          <p className="text-sm font-label text-foreground-600 max-w-md leading-relaxed">
            尽量少加工、多标注，让你听到的接近原本的样子。
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
          {trustPoints.map((point) => (
            <div
              key={point.id}
              className="rounded-lg bg-background-50 border border-background-200 p-5 md:p-6"
            >
              <span className="w-11 h-11 rounded-md bg-primary-100 text-primary-600 flex items-center justify-center">
                <i className={`${point.icon} text-xl`}></i>
              </span>
              <h3 className="mt-4 font-heading font-semibold text-foreground-950 text-base md:text-lg">
                {point.title}
              </h3>
              <p className="mt-2 text-xs md:text-sm font-label text-foreground-600 leading-relaxed">
                {point.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}